<template>
    <div>
    </div>
</template>


<script>
export default {
    
    mounted(){
        // window.location.href = 'https://epass.finbridge.co.kr:39443/ew/ktr?chanCd=W113&teleCoCd=2';
        // window.location.href = 'https://epass.finbridge.co.kr:49443/ew/gdn/join';
        window.location.href = `${process.env.VUE_APP_PRIME_EXT_URL}?chanCd=SE007&teleCoCd=1`;
        
    }
}
</script>